import jsPDF from 'jspdf'
import { applyPlugin } from 'jspdf-autotable'

applyPlugin(jsPDF)

const createPDF = (fileName, head, body) => {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF('landscape', 'mm', 'a4')

  doc.autoTable({
    head: [head],
    body,
    showHead: 'firstPage',
    margin: 5,
    styles: {
      cellPadding: 2,
      fontSize: 8,
      halign: 'center',
      overflow: 'linebreak',
      valign: 'middle',
    },
    headStyles: {
      fillColor: [51, 116, 106],
      textColor: 255,
      fontSize: 8,
      lineWidth: 0.05,
      lineColor: [200, 200, 200],
      halign: 'center',
      valign: 'middle',
    },
    bodyStyles: {
      lineWidth: 0.05,
      lineColor: [200, 200, 200],
    },
  })

  doc.save(`${fileName}.pdf`)
}

export default createPDF
